import {
  INCIDENT_RESPONSE_REQUEST_ASYNC,
  SUBMIT_INCIDENT_RESPONSE_ASYNC,
  UPDATE_DEEP_SETTINGS_FIELD,
  UPDATE_SETTINGS_FIELD,
} from './constants'

const getIncidentResponse = () => ({
  type: INCIDENT_RESPONSE_REQUEST_ASYNC.INITIATE,
})
export const getIncidentResponseSuccess = (data) => ({
  type: INCIDENT_RESPONSE_REQUEST_ASYNC.SUCCESS,
  payload: { data },
})
export const getIncidentResponseError = (error) => ({
  type: INCIDENT_RESPONSE_REQUEST_ASYNC.ERROR,
  error,
})
const getIncidentResponseCancel = () => ({
  type: INCIDENT_RESPONSE_REQUEST_ASYNC.CANCEL,
})

const updateSettingsField = (field, value) => ({
  type: UPDATE_SETTINGS_FIELD,
  payload: { field, value },
})
const updateDeepSettingsField = (field, id, value) => ({
  type: UPDATE_DEEP_SETTINGS_FIELD,
  payload: { field, id, value },
})

const submitIncidentResponse = () => ({
  type: SUBMIT_INCIDENT_RESPONSE_ASYNC.INITIATE,
})
export const submitIncidentResponseSuccess = (data) => ({
  type: SUBMIT_INCIDENT_RESPONSE_ASYNC.SUCCESS,
  payload: { data },
})
export const submitIncidentResponseError = (error) => ({
  type: SUBMIT_INCIDENT_RESPONSE_ASYNC.ERROR,
  error,
})
const submitIncidentResponseCancel = () => ({
  type: SUBMIT_INCIDENT_RESPONSE_ASYNC.CANCEL,
})

export default {
  // to props
  getIncidentResponse,
  getIncidentResponseCancel,
  submitIncidentResponse,
  submitIncidentResponseCancel,
  updateSettingsField,
  updateDeepSettingsField,
}
